import React, {FC} from 'react'

import {observer} from 'mobx-react-lite'

import DragFile from '../DragFile'
import {IDragFileProps} from '../DragFile/DragFile'

interface IMobxDragFileProps extends Omit<IDragFileProps, 'value' | 'onChange'> {
	name: string
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	store: any
}

const MobxDragFile: FC<IMobxDragFileProps> = ({name, store, ...props}) => {
	return (
		<DragFile {...props} value={store[name]} name={name} onChange={(src) => (store[name] = src)} />
	)
}

MobxDragFile.displayName = 'MobxDragFile'

export default observer(MobxDragFile)
